import {
  Gauge, Workflow, Cpu, Zap, FlaskConical,
  ShieldAlert, Leaf, TrendingUp, ClipboardCheck, Activity, Play, Network, List,
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/dashboard", label: "Site", icon: Gauge, testId: "nav-dashboard" },
  { to: "/mimic", label: "Plant Mimic", icon: Workflow, testId: "nav-mimic" },
  { to: "/twins", label: "Digital Twins", icon: Cpu, testId: "nav-twins" },
  { to: "/tags", label: "Tag List", icon: List, testId: "nav-tags" },
  { to: "/energy", label: "Energy & Resource", icon: Zap, testId: "nav-energy" },
  { to: "/yield", label: "Yield & Selectivity", icon: FlaskConical, testId: "nav-yield" },
  { to: "/safety", label: "Safety & Thermal", icon: ShieldAlert, testId: "nav-safety" },
  { to: "/carbon", label: "Carbon & Passport", icon: Leaf, testId: "nav-carbon" },
  { to: "/opportunities", label: "Opportunities", icon: TrendingUp, testId: "nav-opportunities" },
  { to: "/actions", label: "Actions & M&V", icon: ClipboardCheck, testId: "nav-actions" },
  { to: "/quality", label: "Data Quality", icon: Activity, testId: "nav-quality" },
  { to: "/simulation", label: "Simulation", icon: Play, testId: "nav-simulation" },
  { to: "/ontology", label: "Ontology", icon: Network, testId: "nav-ontology" },
];
